export default {
  noDataMessage: 'Aucune donnée trouvée',
};
